import { useCancelCampaignMutation } from 'modules/campaigns/lib';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { useCancelCampaignAlerts } from '../../hooks/useCancelCampaignAlerts';
import { maybeRestErrorMessage } from '../../utils';
import { getCancelCampaignPayload } from './CancelCampaignModal.utils';

export const useCancelCampaign = () => {
  const { closeModal } = useModalContext();
  const { isLoading, mutate, error } = useCancelCampaignMutation();
  const { cancelCampaignAlerts } = useCancelCampaignAlerts();

  const dispatch = useDispatch();

  const { campaign, refetch: refetchCampaign } = useCampaignContext();
  const { campaignAlertsEnabled, id, name } = campaign;

  const cancelCampaign = () => {
    const onSuccess = () => {
      cancelCampaignAlerts({
        campaignIds: [id],
        campaignAlertsEnabled,
      });

      dispatch(addPositiveToast(`${name} cancelled successfully.`));
      closeModal(ModalType.CancelCampaignModal);
      refetchCampaign();
    };

    const onError = (e: unknown) => {
      const errorResponseMessage = maybeRestErrorMessage(e);
      const defaultErrorMessage = 'Error cancelling campaign: something went wrong.';
      const errorMessage = errorResponseMessage || defaultErrorMessage;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'cancelCampaign', e));
    };

    const payload = getCancelCampaignPayload(campaign);

    mutate(payload, {
      onSuccess,
      onError,
    });
  };

  return { isLoading, error, cancelCampaign };
};
